import React from "react";
var d = new Date();

function  Footer(){
  return <footer> © {d.getFullYear()} </footer>
}

export default Footer;